<script>
import { mapState, mapActions } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
   components: {
      VueApexCharts,
   },
   data() {
      return {
         loading: false,
      }
   },
   computed: {
      ...mapState({
         dataResponse: state => state.DashboardSicantik.perBulan,
         tahun: state => state.DashboardSicantik.tahun,
         refreshTimestamp: state => state.DashboardSicantik.refreshTimestamp,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      chartSeries() {
         return [
            {
               name: 'Izin Terbit',
               data: this.dataResponse.data.map(item => item.total),
            },
         ]
      },
      chartOptions() {
         const textColor = this.isDark ? '#b4b7bd' : '#6e6b7b'

         return {
            chart: {
               type: 'bar',
               foreColor: textColor,
               toolbar: {
                  show: false,
               },
               fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
            },
            colors: ['#003083'],
            plotOptions: {
               bar: {
                  borderRadius: 4,
                  columnWidth: '45%',
               },
            },
            dataLabels: {
               enabled: false,
            },
            grid: {
               borderColor: this.isDark ? '#3b4253' : '#ebe9f1',
               strokeDashArray: 4,
            },
            xaxis: {
               categories: this.dataResponse.data.map(item => item.nama_bulan),
               labels: {
                  rotate: -45,
                  style: {
                     colors: textColor,
                  },
               },
               title: {
                  text: 'Bulan',
                  style: {
                     color: textColor,
                  },
               },
            },
            yaxis: {
               min: 0,
               forceNiceScale: true,
               title: {
                  text: 'Jumlah Izin',
                  style: {
                     color: textColor,
                  },
               },
               labels: {
                  style: {
                     colors: [textColor],
                  },
                  formatter: value => Math.round(value),
               },
            },
            tooltip: {
               theme: this.isDark ? 'dark' : 'light',
               y: {
                  formatter: value => `${value} Izin`,
               },
            },
         }
      },
   },
   watch: {
      tahun(newYear, oldYear) {
         if (newYear !== oldYear) this.loadPerBulan(newYear)
      },
      refreshTimestamp() {
         this.loadPerBulan(this.tahun)
      },
   },
   mounted() {
      this.loadPerBulan(this.tahun)
   },
   methods: {
      ...mapActions({
         getPerBulan: 'DashboardSicantik/getPerBulan',
      }),
      async loadPerBulan(year) {
         this.loading = true
         try {
            await this.getPerBulan(year)
         } catch (error) {
            // Chart tetap menampilkan data kosong saat request gagal.
         } finally {
            this.loading = false
         }
      },
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12">
         <b-card class="card-wrapper">
            <b-overlay
               :show="loading"
               :variant="isDark ? 'dark' : 'white'"
               spinner-variant="primary"
               blur="0"
               opacity=".75"
               rounded="sm"
            >
               <div class="d-flex justify-content-between align-items-center mb-1">
                  <div>
                     <h4 class="mb-25">
                        Izin Terbit per Bulan
                     </h4>
                     <small class="text-muted">Periode {{ dataResponse.tahun }}</small>
                  </div>
               </div>
               <vue-apex-charts
                  type="bar"
                  height="350"
                  :options="chartOptions"
                  :series="chartSeries"
               />
            </b-overlay>
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}
</style>
